<template></template>

<script>
export default {
  data() {
    return {};
  },
  created() {
    Auth.logout();
    let lang = localStorage.getItem('lang');
    localStorage.clear();
    localStorage.setItem('lang', lang);
    window.location.reload();
  },
  methods: {}
};
</script>

<style>
</style>
